export const TableLimitlistingOptions = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "40", value: 40 },
    { label: "80", value: 80 },
    { label: "100", value: 100 },
    { label: "All", value: -1 },
]
